const Autres=()=>{
    return (
        <div className="autres-page">
            <h1>Autres</h1>
            <p>Cette page est dédiée aux autres fonctionnalités du magasin.</p>
        </div>
    );
}
 export default Autres;